import React from "react";
import PropTypes from "prop-types";

import {DateRangePickerContextProvider} from "contexts/DateRangePickerContext";

import Dashboard from "./Dashboard";

Index.propTypes = {
    retailer: PropTypes.string,
};

export default function Index(props) {
    return (
        <DateRangePickerContextProvider>
            <Dashboard retailer={props.retailer} />
        </DateRangePickerContextProvider>
    );
}
